import { DashboardCardNameEnum } from "@ryde/shared";

// TODO: Future dev -> take a default view of the cards
export const dashboardCardsNames = [
  DashboardCardNameEnum.RIDE_PAGE_MANUAL_CHANGES_OVERALL,
  DashboardCardNameEnum.OVERALL_COST,
  DashboardCardNameEnum.STATUS_NEW_BOOKINGS,
  DashboardCardNameEnum.RIDE_PAGE_MANUAL_CHANGES_PER_USER,
  DashboardCardNameEnum.VEHICLE_TYPE_RIDES_COST,
  DashboardCardNameEnum.RIDES_SUPPLIERS,
];
